import React, { PureComponent } from 'react'

class TextError extends PureComponent {
  render() {
    const { error = false, message = '' } = this.props
    return <div>{error && <span className="text-error">{message}</span>}</div>
  }
}

export default TextError



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/TextError.js